export const tableValuesPropertyFilter =
  (fetchApi, setNewTableValues) => () => {
    return fetchApi.request('get', '/urproperty/table-values').then((res) => {
      if (res && res.results) setNewTableValues({ payload: res.results });
    });
  };
